// extracted by mini-css-extract-plugin
export default {"buttons":"ToggleSwitch_buttons__o+wNU","toLocal":"ToggleSwitch_toLocal__yjbtg","button":"ToggleSwitch_button__WmAgq","active":"ToggleSwitch_active__ge4Ly"};